import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import { StudioContextProvider } from './context/StudioContext';
import { ToastProvider } from './context/ToastContext';
import { DemoApp } from './pages/demo/DemoApp';
import { LoginPage } from './pages/LoginPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { SignupPage } from './pages/SignupPage';
import { Analytics } from './pages/studio/Analytics';
import { API } from './pages/studio/API';
import { CollectionDetail } from './pages/studio/CollectionDetail';
import { Collections } from './pages/studio/Collections';
import { Dashboard } from './pages/studio/Dashboard';
import { CatalogPage } from './pages/studio/Catalog';
import { Search } from './pages/studio/Search';
import { ThemeProvider } from './theme/studioThemeProvider';
import { RequireAuth } from './util/RequireAuth';
import { useFeatureFlags } from './util/useFeatureFlags';

function App() {
  const { isEnabled } = useFeatureFlags();

  return (
    <ThemeProvider>
      <ToastProvider>
        <StudioContextProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Navigate to="/login" replace />} />
              <Route path="/demo" element={<DemoApp />} />

              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route
                path="/dashboard"
                element={
                  <RequireAuth>
                    <Dashboard />
                  </RequireAuth>
                }
              />
              <Route
                path="/collections"
                element={
                  <RequireAuth>
                    <Collections />
                  </RequireAuth>
                }
              />
              <Route
                path="/collections/:id"
                element={
                  <RequireAuth>
                    <CollectionDetail />
                  </RequireAuth>
                }
              />
              {isEnabled('searchPage') && (
                <Route
                  path="/search"
                  element={
                    <RequireAuth>
                      <Search />
                    </RequireAuth>
                  }
                />
              )}
              <Route
                path="/catalog"
                element={
                  <RequireAuth>
                    <CatalogPage />
                  </RequireAuth>
                }
              />
              <Route
                path="/api"
                element={
                  <RequireAuth>
                    <API />
                  </RequireAuth>
                }
              />
              <Route
                path="/analytics"
                element={
                  <RequireAuth>
                    <Analytics />
                  </RequireAuth>
                }
              />
              {/* 404 page - always available */}
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </BrowserRouter>
        </StudioContextProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;
